import { render, staticRenderFns } from "./AskAction.vue?vue&type=template&id=4fac7886"
import script from "./AskAction.vue?vue&type=script&lang=js"
export * from "./AskAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports